export const Settings = () => import("./Settings.vue");
